import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { OrganizationPublic } from "../models/shared/Organization";
import { ShareToken } from "../models/shared/ShareToken";
import { getDataFromToken } from "../utils/api";

interface State {
    loading: boolean
    organization?: OrganizationPublic | null
    token?: ShareToken | null;
}

export const useShareToken = () => {
    const [state, setState] = useState<State>({ loading: true })
    const { tokenId } = useParams<{ tokenId: string }>();

    useEffect(() => {
        if (!tokenId) {
            setState({ loading: false });
            return;
        }

        const fetchData = async () => {
            try {

                const tokenData = await getDataFromToken(tokenId);
                setState({ loading: false, organization: tokenData.organization, token: tokenData.shareToken });
            } catch (error) {
                console.error('Error fetching token data:', error);
                setState({ loading: false });
            }
        }

        fetchData();
    }, [tokenId]);

    return { ...state, tokenId };
}